import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { customerView, getMilestone } from '../../auth/auth';
import Loader from '../../partial/Loader';
import { formatPoints } from '../../../utils/helper';
import Header from '../../layout/Header';

const TrackTimeline = () => {
  const [loader, setLoader] = useState(true);
  const [customerDetail, setCustomerDetail] = useState([]);
  const [trackData, setTrackData] = useState({});
  const [earningMilestone, setEarningMilestone] = useState(null);
  const [showAddressPopup, setShowAddressPopup] = useState(false);
  const [totalMatchedPoints, setTotalMatchedPoints] = useState(0);
  const location = useLocation();
  const milestone = location?.state?.milestone || false;

  const handleRedeem = () => {

  };

  const handleClosePopup = () => {
    setShowAddressPopup(false);
  };

  const handleRefresh = (e) => {
    e.preventDefault();
    fetchData();
  };

  const parseCustomDate = (dateStr) => {
    const [datePart, timePart, period] = dateStr.split(' ');
    const [month, day, year] = datePart.split('/');
    const [hours, minutes, seconds] = timePart.split(':');
    let hour = parseInt(hours, 10);
    if (period === 'PM' && hour !== 12) hour += 12;
    if (period === 'AM' && hour === 12) hour = 0;
    return new Date(year, month - 1, day, hour, minutes, seconds);
  };

  const token = JSON.parse(localStorage.getItem("token_gen"));
  const fetchData = async () => {
    setLoader(true);
    try {
      const customerCode = localStorage.getItem("customercode");
      const customerRes = await customerView(token.access_token, customerCode);
      const customerData = customerRes?.transactions || [];
      setCustomerDetail(customerData);

      const customerid = localStorage.getItem('customerid');
      const milestoneRes = await getMilestone(token.access_token, customerid);
      setEarningMilestone(milestoneRes);

      const data = milestoneRes?.data?.[0] || {};
      const activities = data.Activity || [];
      const bonusActivities = data.BonusActivities || [];
      const totalGoal = data.RewardsDetails?.totalpoint || 0;
      const customerCreatedDate = data.Customer?.createdDate;
      if (customerCreatedDate && customerData.length > 0) {
        const filteredCustomerDetails = customerData.filter(
          (detail) => new Date(detail.createdDate) > parseCustomDate(customerCreatedDate)
        );

        const allCampaignCodes = [
          ...activities.map((activity) => activity.campaignCode),
          ...bonusActivities.map((bonusActivity) => bonusActivity.campaignCode),
        ];

        const customerCampaignValues = customerData
          .flatMap((detail) => detail.qualifiedCampaign || [])
          .filter((qc) => qc.walletFor === 'Customer')
          .reduce((sum, qc) => sum + (qc.value || 0), 0);
        const pointsRemaining = totalGoal - customerCampaignValues;
        setTotalMatchedPoints(customerCampaignValues);
        setTrackData({
          overallProgress: totalGoal > 0
            ? `${Math.round(Math.min((customerCampaignValues / totalGoal) * 100, 100))}%`
            : '0%',
          pointsRemaining: pointsRemaining > 0 ? pointsRemaining : 0,
        });
      }
    } catch (err) {
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const customerCreatedDate = earningMilestone?.data?.[0]?.Customer?.createdDate;
  const filteredCustomerDetails = customerCreatedDate
    ? customerDetail.filter((detail) => new Date(detail.createdDate) > parseCustomDate(customerCreatedDate))
    : [];

  const combinedActivities = [
    ...(earningMilestone?.data?.[0]?.Activity || []).map((activity) => {
      const campaignValue = filteredCustomerDetails
        .flatMap((detail) => detail.qualifiedCampaign || [])
        .filter((qc) => qc.walletFor === 'Customer' && qc.campaignId === activity.campaignCode)
        .reduce((sum, qc) => sum + (qc.value || 0), 0);
      const campaignCount = filteredCustomerDetails
        .flatMap((detail) => detail.qualifiedCampaign || [])
        .filter((qc) => qc.walletFor === 'Customer' && qc.campaignId === activity.campaignCode)
      return {
        title: activity.activityType,
        progress: `${activity.totalcount}`,
        complete: campaignValue > 0 ? `${Math.round(Math.min((campaignValue / activity.points) * 100, 100))}%` : '0%',
        campaignValue,
        campaignCount
      };

    }),
    ...(earningMilestone?.data?.[0]?.BonusActivities || []).map((bonusActivity) => {
      const campaignValue = filteredCustomerDetails
        .flatMap((detail) => detail.qualifiedCampaign || [])
        .filter((qc) => qc.walletFor === 'Customer' && qc.campaignId === bonusActivity.campaignCode)
        .reduce((sum, qc) => sum + (qc.value || 0), 0);
      const campaignCount = filteredCustomerDetails
        .flatMap((detail) => detail.qualifiedCampaign || [])
        .filter((qc) => qc.walletFor === 'Customer' && qc.campaignId === bonusActivity.campaignCode)
      return {
        title: bonusActivity.activityType,
        progress: `${bonusActivity.totalcount}`,
        complete: campaignValue > 0 ? `${Math.round(Math.min((campaignValue / bonusActivity.points) * 100, 100))}%` : '0%',
        campaignValue,
        campaignCount
      };
    }),
  ];

  const navigate = useNavigate()
  const goToPreviousTab = () => {
    navigate(-1);
  };


  return (
    <>
      <Header goToPreviousTab={goToPreviousTab} isHomePage={false} />
      <main>
        {milestone && (
          <div className="popup show" id="congratulationspopup">
            <div className="popup-box">
              <a
                href="javascript:void(0)"
                className="close-popup"
                id="closecongratulationspopup"
                onClick={handleClosePopup}
              >
                X
              </a>
              <div className="popup-box-congratulations">
                <span>
                  <img src="images/confetti.png" alt="Confetti" />
                </span>
                <h4>Congratulations</h4>
                <p>You're one step closer to achieving your reward. Keep tracking your progress to reach your goal!</p>
                <Link to="/home" className="btn btn-block" onClick={handleClosePopup}>
                  Back to Home
                </Link>
              </div>
            </div>
          </div>
        )}
        {loader && <Loader />}

        <div className="timeline">
          <div className="timeline-content">
            <div className="timeline-content-inner active" id="track_timeline">
              <div className="timeline-track">
                <div className="timeline-track-box">
                  <div className="timeline-track-box-header">
                    <div className="timeline-track-box-header-top">
                      <div className="timeline-track-box-header-top-left">
                        <div className="trip-target">
                          <div className="trip-target-left">
                            <span>
                              <img src="images/ribbon.svg" alt="trophy" />
                            </span>
                          </div>
                          <div className="trip-target-right">
                            <h4>{earningMilestone?.data?.[0]?.RewardsDetails?.Name || 'Loading...'}</h4>
                            <p>
                              {formatPoints(earningMilestone?.data?.[0]?.RewardsDetails?.totalpoint) || 0} points goal
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="timeline-track-box-header-top-right">
                        <a href="#" onClick={handleRefresh}>
                          <span>
                            <img src="images/refresh.png" alt="refresh" />
                          </span>
                        </a>
                      </div>
                    </div>
                    <div className="timeline-track-box-header-bottom">
                      <div className="timeline-track-box-header-bottom-left">
                        <p>Overall Progress</p>
                        <h3>{trackData.overallProgress || '0%'}</h3>
                      </div>
                      <div className="timeline-track-box-header-bottom-right">
                        <p>Total Points</p>
                        <h3>{formatPoints(totalMatchedPoints) || 0}</h3>
                      </div>
                    </div>
                    <div className="timeline-track-progress">
                      <div className="timeline-track-progress-container">
                        <div
                          className="timeline-track-progress-fill"
                          style={{ width: trackData.overallProgress || '0%' }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="timeline-track-box-middle">
                    <div className="timeline-track-box-middle-box">
                      <div className="timeline-track-box-middle-box-left">
                        <div className="timeline-track-box-middle-box-left-inner">
                          <p>
                            <img src="images/time-slot.png" alt="time slot" />
                            Timeline
                          </p>
                          <h5>{earningMilestone?.data?.[0]?.Timeline?.EndDate || 'N/A'}</h5>
                        </div>
                      </div>
                      <div className="timeline-track-box-middle-box-right">
                        <div className="timeline-track-box-middle-box-right-inner">
                          <p>
                            <img src="images/remaining.png" alt="time slot" />
                            Points Remaining
                          </p>
                          <h5>{formatPoints(trackData.pointsRemaining) || 0}</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="timeline-track-box-bottom">
                    <h4>Activity Progress</h4>
                    <div className="timeline-track-box-bottom-row">
                      {combinedActivities.length > 0 ? (
                        combinedActivities.map((activity, index) => (
                          <div key={index} className="timeline-track-box-bottom-box">
                            <div className="timeline-track-box-bottom-box-top">
                              <div className="timeline-track-box-bottom-box-top-left">
                                <h5><img src="images/green-check.svg" alt="check" /> {activity.title}</h5>
                              </div>
                              <div className="timeline-track-box-bottom-box-top-right">
                                {activity.title === "Upload Invoices" ? <p>{`${activity.campaignCount.length || 0}/${formatPoints(activity.progress)}`}L  invoice value </p> : activity.title === "Onboard Retailers" ? <p>{`${activity.campaignCount.length || 0}/${formatPoints(activity.progress)}`} retailers referrals</p> : activity.title === "Refer Brands" ? <p>{`${activity.campaignCount.length || 0}/${formatPoints(activity.progress)}`} brands referrals</p> : <p>{`${activity.campaignCount.length || 0}/${formatPoints(activity.progress)}`} distributors referrals</p>}

                              </div>
                            </div>
                            <div className="timeline-track-box-bottom-box-middle">
                              <div className="timeline-track-progress-container">
                                <div
                                  className={`timeline-track-progress-fill ${activity.complete === '100%' ? 'full' : ''}`}
                                  style={{ width: activity.complete }}
                                ></div>
                              </div>
                            </div>
                            <div className="timeline-track-box-bottom-box-bottom">
                              <div className="timeline-track-box-bottom-box-bottom-left">
                                <p>{activity.complete} complete</p>
                              </div>
                              <div className="timeline-track-box-bottom-box-bottom-right">
                                <p>{formatPoints(activity.campaignValue)} points earned</p>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <p>No activities available</p>
                      )}
                    </div>
                  </div>
                  {trackData.pointsRemaining === 0 ? (
                    <div className="timeline-track-box-congratulations">
                      <div className="timeline-track-box-congratulations-box">
                        <h4>Congrats</h4>
                        <p>You've successfully earned enough points to claim your selected reward.</p>
                        <p>Total Points Earned from Matched Campaigns: {totalMatchedPoints.toLocaleString()}</p>
                        <button
                          className="btn btn-block btn-success"
                          onClick={handleRedeem}
                          disabled={trackData.pointsRemaining !== 0}
                        >
                          Redeem Reward Now
                        </button>
                      </div>
                    </div>
                  ) : <div className="timeline-track-box-disabled">
                    <button
                      className="btn btn-block btn-disabled opacity-05"
                      onClick={handleRedeem}
                      disabled={trackData.pointsRemaining !== 0}
                    >
                      Redeem Reward Now
                    </button>
                  </div>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default TrackTimeline;
